import { Table, Modal, Button, Col, Row, Dropdown } from "react-bootstrap";
import { BarreReseau, Distance, engineStat, getAddressFromCoordinates, getReportName, toTimestamp, ValidatePosition } from "../utilities/functions";
import { useTranslate } from "../hooks/LanguageProvider";
import ExcelJS, { Style } from "exceljs";
import MapModal from "../components/Map/MapModal";
import Linecharts, { ChartData } from "../components/Charts/Linecharts";
import { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useClipboard } from "../utilities/functions";
import { PropagateLoader } from 'react-spinners'
import ReactPaginate from "react-paginate";


const backendUrl = process.env.REACT_APP_BACKEND_URL;
interface Position {
  id_position: number;
  PSN: string;
  TIMESTAMP: string; // format ISO (ex: "2025-05-10T10:17:32.000Z")
  ENGINESTAT: number;
  LAT: number;
  LON: number;
  ALT: number;
  SOG: number; // Speed Over Ground
  GSMLVL: number | null;
  NST: number;
  GPSDIST: number;
  COG: number; // Course Over Ground
  GUS: number;
}


export function PositionTracking() {

  const { from_date, to_date, search_term } = useParams<{ from_date?: string; to_date?: string; search_term?: string }>();
  const user_id = localStorage.getItem("userid");

  const [startDate, setStartDate] = useState<Dayjs>(dayjs().startOf("day"));
  const [endDate, setEndDate] = useState<Dayjs>(dayjs().endOf("day"));
  const [search, setSearch] = useState("");


  useEffect(() => {
    if (search_term) {
      setSearch(decodeURIComponent(search_term));
    }

    if (from_date) {
      const decodedFrom = decodeURIComponent(from_date); // "2025-05-06 17:59:18"
      const parsedFrom = dayjs(decodedFrom);
      if (parsedFrom.isValid()) {
        setStartDate(parsedFrom.subtract(2, "minute"));
      }
    }

    if (to_date) {
      const decodedTo = decodeURIComponent(to_date); // "2025-05-06 17:59:18"
      const parsedTo = dayjs(decodedTo);
      if (parsedTo.isValid()) {
        setEndDate(parsedTo.add(2, "minute"));
      }
    }
  }, [from_date, to_date, search_term]);


  const { translate } = useTranslate();
  const [positions, setPositions] = useState<Position[]>([]);
  const [pageCount, setPageCount] = useState(0);
  let [total, setTotal] = useState(0);
  let [limitValue, setSelectedLimitValue] = useState(10);
  const [loading, setLoading] = useState(false);
  const [modalStatus, setModalStatus] = useState<string | null>(null);
  const [titleStatus, setTitleStatus] = useState<string | null>(null);
  const [IdUser, setIdUser] = useState<number>(0);
  const [IdVehicle, setIdVehicle] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [column, setSortColumn] = useState("immatriculation_vehicule");
  const [sort, setSort] = useState("ASC");

  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const { copyToClipboard, copiedId } = useClipboard(translate("Matriculation Copied"));
  const [selectedVehicles, setSelectedVehicles] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);


  const handleColumnChange = (column: string) => {
    setSelectedColumns((prevState: any) => ({
      ...prevState,
      [column]: !prevState[column],
    }));
  };
  const handleSortingColum = (currentColumn: string) => {

    sort == "DESC" ? setSort("ASC") : setSort("DESC");
    setSortColumn(currentColumn);
    setCurrentPage(1)
    //getVehicles(limitValue, 1, search, type, column, sort);
  };


  const handlePageClick = async (data: any) => {
    let currentPage = data.selected + 1;
   await getPositions(limitValue, currentPage, search, type, column, sort, toTimestamp(startDate.toISOString()), toTimestamp(endDate.toISOString()));
    setCurrentPage(currentPage)
    window.scrollTo(0, 0)
  };



  const [selectedColumns, setSelectedColumns] = useState({
    id_vehicule: true,
    immatriculation_vehicule: true,
    vehicule_type: true,
    id_dispositif: true,
    nom_groupe: true,
    username_user: true,
    PSN: true,
    GPSDIST: true,
  });

  const searchColumn: { [key: string]: number } = {
    id_vehicule: 0,
    vehicule_type: 1,
    immatriculation_vehicule: 2,
    PSN: 3,
    username_user: 4,
    nom_groupe: 5,
    odometer: 6,
  };


  const [reportData, setReportData] = useState<any>([]);

  const [modalInfo, setModalInfo] = useState<{
    show: boolean;
    lat: number;
    lng: number;
  }>({ show: false, lat: 0, lng: 0 });





  const getPositions = async (
    limit: number,
    page: number,
    search: string,
    type: number,
    column: string,
    sort: string,
    from_date: string,
    to_date: string
    // filters: Filters
  ) => {

    const bodyData = JSON.stringify({
      limit: limit,
      page: page,
      search: search,
      type: type,
      id_user: user_id,
      column: column,
      sort: sort,
      from_date: from_date,
      to_date: to_date
      //  filters: filters
    });

    try {
      setLoading(true);

      const total_pages = await fetch(`${backendUrl}/api/position/totalpage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
        mode: "cors",
      });

      const totalPages = await total_pages.json();
      total = totalPages[0]["total"];
      setTotal(totalPages[0]["total"]);

      const vehicleResponse = await fetch(`${backendUrl}/api/position/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
        mode: "cors",
      });

      if (!vehicleResponse.ok) {
        console.error("Error retrieving vehicles list");
        setLoading(false);
        return;
      }

      const data = await vehicleResponse.json();
      setPageCount(Math.ceil(total / limit));
      setReportData(data)
      setPositions(data);
      return data;
    } catch (error) {
      console.error(
        "Error retrieving data from table",
        error
      );
    } finally {
      setLoading(false);
    }
  };




  const apiData = reportData || [];

  let prevCumulativeDistance: number;
  let cumulativeSum = 0;

  // calcule distance


  // calcule distance cumulée
  const lineChartResult = apiData.map((item: any, index: number) => {
    // Initialisation de prevCumulativeDistance à la première distance GPSDIST
    if (prevCumulativeDistance == null) {
      prevCumulativeDistance = item.GPSDIST;
    }

    // Calcul de la différence entre la distance actuelle et la précédente
    const difference = item.GPSDIST - prevCumulativeDistance;

    // Ajout de la différence à la somme cumulative
    cumulativeSum += difference;

    // Mettre à jour prevCumulativeDistance pour la prochaine itération
    prevCumulativeDistance = item.GPSDIST;

    return {
      ...item,
      cumulativeDifference: cumulativeSum / 1000, // Conversion en kilomètres
    };
  });

  console.log(lineChartResult);


  const transformedSOGData = apiData.map((item: any) => [
    new Date(item.TIMESTAMP).getTime(),
    item.SOG,
  ]);

  const transformedEngineStatData = apiData.map((item: any) => [
    new Date(item.TIMESTAMP).getTime(),
    item.ENGINESTAT,
  ]);

  const handlePointClick = (lat: number, lng: number) => {
    // console.log('Marker clicked - Lat:', lat, 'Lng:', lng);
    setModalInfo({ show: true, lat, lng }); // Mettre à jour les coordonnées dans le state du modalInfo
  };

  const sampleData: ChartData = {
    chartTitle: translate("Diagramme de distance, vitesse et contact"),
    chartTitleAlign: "center",
    enabledLegend: true,
    height: 400,

    series: [
      {
        name: translate("Vitesse"),
        unit: " km/h",
        description: translate("Vitesse"),
        data: transformedSOGData,
        color: "#41b346",
        type: "spline",
        yAxisState: true,
        labels: {
          format: "{value}",
          style: {
            color: "#41b346",
          },
        },
        events: {
          click: (event: any) => {
            const point = event.point;
            const index = point.index;
            const item = apiData[index];
            // console.log("Point clicked:", item); // Log pour le débogage
            setModalInfo({ show: true, lat: item.LAT, lng: item.LNG });
          },
        },
      },

      {
        name: translate("Engine Stat"),
        unit: "",
        description: translate("Engine Stat"),
        data: transformedEngineStatData,
        color: "#EB1D36",
        type: "spline",
        yAxis: 1,
        yAxisState: true,
        labels: {
          format: "{value}",
          style: {
            color: "#EB1D36",
          },
        },
        events: {
          click: (event: any) => {
            const point = event.point;
            const index = point.index;
            const item = apiData[index];
            // console.log("Point clicked:", item); // Log pour le débogage
            setModalInfo({ show: true, lat: item.LAT, lng: item.LNG });
          },
        },
      },

      {
        name: translate("Distance"),
        unit: " km",
        description: translate("Distance"),
        data: lineChartResult.map((item: any) => [
          new Date(item.datetime).getTime(),
          item.cumulativeDifference,
        ]),
        color: "#0080FF",
        type: "spline",
        yAxisState: true,
        labels: {
          format: "{value}",
          style: {
            color: "#0080FF",
          },
        },
        events: {
          click: (event: any) => {
            const point = event.point;
            const index = point.index;
            const item = apiData[index];
            // console.log("Point clicked:", item); // Log pour le débogage
            setModalInfo({ show: true, lat: item.LAT, lng: item.LNG });
          },
        },
      },
    ],
  };

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      "Diagramme de distance, vitesse et contact"
    );

    // Add the title row with uppercase and bold style, spanning three columns
    const titleRow = worksheet.addRow([
      "",
      "Diagramme de distance, vitesse et contact:",
      "",
    ]);
    titleRow.getCell(2).font = { bold: true, size: 14, name: "Arial" }; // Set font to bold for the middle cell (B1)
    titleRow.getCell(2).alignment = {
      vertical: "middle",
      horizontal: "center",
    }; // Align text in the middle for the middle cell (B1)
    titleRow.eachCell((cell) => {
      cell.font = { bold: true, size: 14, name: "Arial" }; // Set font to bold for all cells
      cell.alignment = { vertical: "middle", horizontal: "center" }; // Align text in the middle for all cells
      if (typeof cell.value === "string") {
        cell.value = cell.value.toUpperCase(); // Convert text to uppercase if it's a string
      }
    });

    // Add the "Creation Date" row
    const creationDateRow = worksheet.addRow([
      "Creation Date:",
      new Date(reportData.moreInfo?.date_creation).toLocaleString(),
    ]);
    creationDateRow.eachCell((cell) => {
      cell.font = { color: { argb: "0000FF" } }; // Set font color to blue
    });

    // Add the "Immatriculation Véhicule" and "Turn Report" row
    const vehicleImmatriculationRow = worksheet.addRow([
      "Immatriculation Véhicule:",
      reportData.moreInfo?.immatriculation_vehicule || "N/A",
      "Turn Report:",
      reportData.moreInfo?.turn_report || "N/A",
    ]);
    vehicleImmatriculationRow.eachCell((cell) => {
      cell.font = { color: { argb: "0000FF" } }; // Set font color to blue
    });
    // Merge cells for the title
    worksheet.mergeCells("A5:H5");

    const headerStyle: Partial<Style> = {
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFCCCCCC" },
      },
      font: {
        bold: true,
        size: 10, // Adjust font size as needed
        name: "Arial", // Specify the font family
        underline: false,
        italic: false,
        vertAlign: undefined, // or remove this line if you don't need it
        outline: false,
        strike: false,
        color: { argb: "FFFFFFFF" }, // remove one of the duplicate properties
      },
    };

    worksheet.addRow([
      "Date/Time Start",
      "Date/Time End",
      "Start Distance",
      "End Distance",
      "Difference",
      "Average Speed (km/h)",
      "Max Speed (km/h)",
      "Speed Status",
    ]);
    worksheet.getRow(6).eachCell({ includeEmpty: true }, (cell) => {
      cell.style = headerStyle;
    });
    // Add data row from reportData to worksheet
    const row = worksheet.addRow([
      new Date(reportData.moreInfo?.date_debut).toLocaleString(),
      new Date(reportData.moreInfo?.date_fin).toLocaleString(),
      apiData.length > 0 ? `${apiData[0].distance} KM ` : "No Data",
      apiData.length > 0
        ? `${apiData[apiData.length - 1].distance} KM `
        : "No Data",
      apiData.length > 0
        ? `${apiData[apiData.length - 1].distance - apiData[0].distance} KM`
        : "No Data",
      reportData.additionalData?.average_speed != null
        ? Number(reportData.additionalData.average_speed).toFixed(2)
        : "0",
      reportData.additionalData?.max_speed.toFixed(2),
      reportData.additionalData?.max_speed > 90
        ? "Excess Speed"
        : "No Excess Speed",
    ]);

    // Set text color based on condition (red for "Excess Speed", green otherwise)
    const speedStatusCell = row.getCell(8); // Assuming "Speed Status" is the 8th column
    speedStatusCell.font = {
      color: {
        argb:
          reportData.additionalData?.max_speed > 90 ? "FFFF0000" : "FF00FF00",
      },
    };

    // Auto adjust column widths to fit the content
    worksheet.columns.forEach((column) => {
      column.width = Math.max(column.width ?? 0, 30); // Use 0 as the default width if column.width is undefined
    });

    // Generate Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    // Get the current date for the filename
    const currentDate = new Date();
    const dateString = currentDate.toISOString().split("T")[0]; // Get the date part of the ISO string

    // Update the filename to include the creation date
    const fileName = `Diagramme de distance, vitesse et contact_${dateString}.xlsx`;
    // Create download link and click it to trigger download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  };

  const renderMaxSpeedStatus = () => {
    if (reportData.additionalData?.max_speed > 90) {
      return (
        <>
          <i className="las la-tachometer-alt" style={{ color: "red" }}></i>
          <span style={{ color: "red" }}> {translate("Excès de vitesse")}</span>
        </>
      );
    } else {
      return (
        <>
          <i className="las la-tachometer-alt" style={{ color: "green" }}></i>
          <span style={{ color: "green" }}>
            {" "}
            {translate("Pas d'excès de vitesse")}
          </span>
        </>
      );
    }
  };

  const menuItems = [
    translate("Matriculation"),
    translate("PSN"),
  ];



  const handleStartDateChange = (newDate: Dayjs | null) => {
    if (newDate) {
      if (newDate.isAfter(endDate)) {
        console.warn(
          "⚠️ La date de début ne peut pas dépasser la date de fin !"
        );
        return;
      }

      setStartDate(newDate);

    }
  };

  const handleEndDateChange = (newDate: Dayjs | null) => {
    if (newDate) {
      if (newDate.isBefore(startDate)) {
        console.warn(
          "⚠️ La date de fin ne peut pas être avant la date de début !"
        );
        return;
      }

      setEndDate(newDate);

    }
  };
  const [typeSearch, setTypeSearch] = useState("Immatriculation");
  const [selectedSearch, setSelectedSearch] = useState(translate("Immatriculation"));
  const [type, setType] = useState(0);


  const handleTypeSearch = (selectedValue: string) => {


    switch (selectedValue) {

      case translate("Matriculation"):
        setSelectedSearch(translate("Matriculation"))
        setType(0);
        break;
      case translate("PSN"):
        setSelectedSearch(translate("PSN"))
        setType(1);
        break;
      case translate("Vehicles Groups"):
        setSelectedSearch(translate("Vehicles Groups"))
        setType(2);
        break;
      case translate("User"):
        setSelectedSearch(translate("User"))
        setType(3);
        break;
      case translate("Driver"):
        setSelectedSearch(translate("Driver"))
        setType(4);
        break;
      default:
        // console.log("Unknown selection");
        break;
    }

    setTypeSearch(translate(selectedValue));
    // console.log("Selected value:", selectedValue);
  };


  const handleTypeAdvancedSearch = async (event: any) => {
    const newValue = event.target.value;
    setSearch(newValue);

  };

  const handleAdvancedSearch = async (event: any) => {
    const newValue = event.target.value;
    setSearch(newValue);
    await getPositions(limitValue, pageCount, newValue, type, column, sort, toTimestamp(startDate.toISOString()), toTimestamp(endDate.toISOString()));
  };


  const handleResetSearch = async () => {
    setSearch("")

    // await getFleet(limit, page, search, type, column, sort, filters)
  };


  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    setCurrentPage(0);
    setSelectedLimitValue(newValue);
    const commentsFormServer = await getPositions(
      parseInt(newValue),
      1,
      search,
      type,
      column,
      sort,
      toTimestamp(startDate.toISOString()), toTimestamp(endDate.toISOString()));
    setPositions(commentsFormServer)
    window.scrollTo(0, 0);
  };


  const fetchAddress = async (LAT: number, LON: number) => {
    try {
      return await getAddressFromCoordinates(LAT, LON); // Utilise renderPosition pour récupérer l'adresse
    } catch (error) {
      console.error("Erreur lors de la récupération de l'adresse", error);
      return "Adresse non disponible"; // Retourne une adresse par défaut en cas d'erreur
    }
  };


  const [addresses, setAddresses] = useState<{ [key: number]: string }>({}); // Stocke les adresses par id_position

  useEffect(() => {
    const fetchAllAddresses = async () => {
      const newAddresses: { [key: number]: string } = {};
      for (const position of positions) {
        if (position.LAT && position.LON) {
          const address = await fetchAddress(position.LAT, position.LON);
          newAddresses[position.id_position] = address;
        }
      }
      setAddresses(newAddresses); // Met à jour les adresses après récupération
    };

    if (positions.length > 0) {
      fetchAllAddresses(); // Récupère les adresses uniquement si positions existe
    }
  }, [positions]); // Relance l'effet à chaque changement de positions
  const [markerCoordinates, setMarkerCoordinates] = useState({ LAT: 0, LON: 0, });
  const [showMapModal, setShowMapModal] = useState(false);
  const handleMapIconClick = (LAT: number, LON: number) => {
    setMarkerCoordinates({ LAT, LON });
    setShowMapModal(true);
  };

  return (
    <>
      <div style={{ marginTop: "10px" }}>
        <h5>
          {translate("Positions tracking")}
        </h5>
        <p>
          <button
            className="btn btn-outline-info"
            style={{ position: "absolute", top: "0", right: "0" }}
            onClick={exportToExcel}
          >
            <i className="las la-file-alt mr-3"></i>
            {translate("Download")} Excel
          </button>
        </p>
      </div>
      <div style={{ marginTop: "10px", marginLeft: "0px", position: "relative" }}>
        <Row style={{ marginBottom: "15px" }}>
          <div
            className="col-md-3"
            style={{ margin: "0px 0px 10px 0px" }}
          >
            <div>{translate("Positions search")}</div>
            <div className="input-group">

              <Dropdown>
                <Dropdown.Toggle variant="link" id="dropdown-custom" className="custom-toggle">
                  <i
                    className="fas fa-chevron-down"
                    style={{ fontSize: "20" }}
                  ></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {menuItems.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => handleTypeSearch(item)}
                      eventKey={item}
                      active={typeSearch === item}
                      className={typeSearch === item ? "select-active" : ""}
                    >
                      {item}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <input
                type="text"
                placeholder={` ${translate("Search by")} ${translate(typeSearch)}`}
                value={search}
                onChange={handleTypeAdvancedSearch}
                className="form-control" />
              <Button
                variant="secondary"
                onClick={handleAdvancedSearch}
                className="btn-reset"
                style={{ marginRight: " 4px" }}
              >
                <i className="las la-search" style={{ color: "#fff" }}></i>
              </Button>
              <Button
                variant="secondary"
                onClick={handleResetSearch}
                className="btn-reset"
              >
                <i className="las la-times" style={{ color: "#fff" }}></i>
              </Button>
            </div>
          </div>
          <Col md={3} >
            <div>{translate("Start date")}</div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <i
                className="las la-calendar d-inline icon-report"
                style={{ marginRight: "0px", fontSize: "1.2rem" }}
              ></i>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="fr"
              >
                <DateTimePicker
                  //label="Date de début"
                  value={startDate}
                  onChange={handleStartDateChange}
                  ampm={false} // Format 24h
                  format="YYYY-MM-DD HH:mm:ss"
                  maxDate={dayjs()}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      sx: {
                        "& .MuiOutlinedInput-root": {
                          height: 40, // ✅ Réduit la hauteur
                          fontSize: "14px", // ✅ Texte plus petit
                          "& fieldset": { borderColor: "#ddd" }, // ✅ Bordure orange
                          "&:hover fieldset": { borderColor: "#e76f33" }, // ✅ Bordure plus foncée au survol
                          "&.Mui-focused fieldset": {
                            borderColor: "#d95c1e",
                          }, // ✅ Bordure plus intense en focus
                        },
                        "& .MuiInputLabel-root": {
                          color: "#ff7e41", // ✅ Couleur du label
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#d95c1e", // ✅ Couleur du label en focus
                        },
                      },
                    },
                  }} // ✅ Nouvelle méthode
                />
              </LocalizationProvider>
            </div>
          </Col>

          <Col md={3}>
            <div>{translate("End date")}</div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <i
                className="las la-calendar d-inline icon-report"
                style={{ marginRight: "0px", fontSize: "1.2rem" }}
              ></i>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="fr"
              >
                <DateTimePicker
                  //  label="Date de fin"
                  value={endDate}
                  onChange={handleEndDateChange}
                  ampm={false}
                  format="YYYY-MM-DD HH:mm:ss"
                  maxDate={dayjs()}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      sx: {
                        "& .MuiOutlinedInput-root": {
                          height: 40, // ✅ Réduit la hauteur
                          fontSize: "14px", // ✅ Texte plus petit
                          "& fieldset": { borderColor: "#ddd" }, // ✅ Bordure orange
                          "&:hover fieldset": { borderColor: "#e76f33" }, // ✅ Bordure plus foncée au survol
                          "&.Mui-focused fieldset": {
                            borderColor: "#d95c1e",
                          }, // ✅ Bordure plus intense en focus
                        },
                        "& .MuiInputLabel-root": {
                          color: "#ff7e41", // ✅ Couleur du label
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#d95c1e", // ✅ Couleur du label en focus
                        },
                      },
                    },
                  }} // ✅ Nouvelle méthode
                />
              </LocalizationProvider>
            </div>
          </Col>
          <div className="col-md-3 d-flex justify-content-end align-items-center">
            <div className="dataTables_length" id="DataTables_Table_0_length">
              <label style={{ marginBottom: "0" }}>
                {translate("Show")}
                <select
                  name="DataTables_Table_0_length"
                  aria-controls="DataTables_Table_0"
                  className="custom-select custom-select-sm form-control form-control-sm ml-2"
                  style={{ width: "66px" }}
                  onChange={handleSelectChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </select>
              </label>
            </div>
            <Dropdown>
              <Dropdown.Toggle
                variant=""
                id="dropdown-basic"
                title={translate("Display columns")}
              >
                <i className="las la-eye"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.id_vehicule}
                    onChange={() => handleColumnChange("id_vehicule")}
                  />
                  <span style={{ marginLeft: "10px" }}>
                    {translate("ID")}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.immatriculation_vehicule}
                    onChange={() => handleColumnChange("immatriculation_vehicule")}
                  />
                  <span style={{ marginLeft: "10px" }}>{translate("Matriculation")}</span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.PSN}
                    onChange={() => handleColumnChange("PSN")}
                  />
                  <span style={{ marginLeft: "10px" }}>{translate("PSN")}</span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.username_user}
                    onChange={() => handleColumnChange("username_user")}
                  />
                  <span style={{ marginLeft: "10px" }}>{translate("User")}</span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.nom_groupe}
                    onChange={() => handleColumnChange("nom_groupe")}
                  />
                  <span style={{ marginLeft: "10px" }}>{translate("Group")}</span>
                </Dropdown.Item>

                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.GPSDIST}
                    onChange={() => handleColumnChange("GPSDIST")}
                  />
                  <span style={{ marginLeft: "10px" }}>
                    {translate("Odometer")}
                  </span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Row>
      </div>

      <>
        <div className="row">


        </div>
        <div>

          <div className="row">


          </div>
          <div className="row">
            <div className="table-responsive">
              <Table className="dataTable">
                <thead className="bg-white text-uppercase">
                  <tr className="ligth ligth-data">
                    <th>
                      <div className="checkbox d-inline-block">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectAll}
                        //   onChange={(e) => handleSelectAllVehicles(e.target.checked)}
                        />
                        <label className="form-check-label"></label>
                      </div>
                    </th>
                    {selectedColumns.id_vehicule && (<th className="sorting" onClick={() => handleSortingColum("id_vehicule")} > {translate("Date")} </th>)}
                    {selectedColumns.vehicule_type && (<th className="sorting" onClick={() => handleSortingColum("vehicule_type")}   >  {translate("Type")} </th>)}
                    {selectedColumns.GPSDIST && (<th className="sorting" onClick={() => handleSortingColum("GPSDIST")}  > {translate("Odometer")}  </th>)}
                    <th>{translate('Statute')}</th>
                    <th>{translate('Actions')}</th>
                  </tr>
                </thead>
                <tbody key="#" className="ligth-body">
                  {loading ? (
                    <tr style={{ textAlign: "center" }}>
                      <td className="text-center" colSpan={10}>
                        <p>
                          <PropagateLoader color={"#123abc"} loading={loading} size={20} />
                        </p>
                      </td>
                    </tr>

                  ) : positions.length > 0 ? (
                    positions.map((position) => (

                      <tr className={position.id_position.toString()}>
                        <td>
                          <div className="checkbox d-inline-block">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`checkbox-${position["id_position"]}`}
                              checked={selectedVehicles.includes(position["id_position"].toString())}
                            //  onChange={() => handleVehiclesSelect(item["id_vehicule"].toString())}
                            />
                            <label htmlFor={`checkbox-${position["id_position"]}`} className="mb-0"></label>
                          </div>
                        </td>
                        {selectedColumns.id_vehicule && <td>{toTimestamp(position.TIMESTAMP)}</td>}
                        {selectedColumns.id_vehicule && (
                          <td>
                            <div className="align-items-center">

                              <div>
                                {"Satellites: "} {position.GUS} <br />
                                {"Speed: "}{position.SOG}  {"Km/h"}
                                <p className="mb-0">
                                  <small>{addresses[position.id_position] || "Loading..."}</small>
                                </p>
                              </div>
                            </div>
                          </td>
                        )}
                        {selectedColumns.GPSDIST && <td>{Distance(position.GPSDIST)}</td>}
                        <td>
                          {position["GSMLVL"] !== null
                            ? position["GSMLVL"].toFixed(0)
                            : "0"}
                          %{""}
                          {position["GSMLVL"] !== null && (
                            <i
                              style={{
                                color: BarreReseau(position["GSMLVL"])
                                  .split("color:")[1]
                                  .slice(0, -1),
                              }}
                              className={`las la-signal ${BarreReseau(
                                position["GSMLVL"]
                              )}`}
                            ></i>
                          )}

                          {position["NST"] === 1 ? (
                            <i className={ValidatePosition(position["NST"])}></i>
                          ) : (
                            <i className={ValidatePosition(position["NST"])}></i>
                          )}
                          <img
                            src={
                              engineStat(
                                position["ENGINESTAT"],
                                position["SOG"],
                                translate
                              ).iconState
                            }
                            alt=""
                            title={
                              engineStat(
                                position["ENGINESTAT"],
                                position["SOG"],
                                translate
                              ).tooltipMessage
                            }
                          />
                        </td>

                        <td>
                          <div className="d-flex align-items-center list-action">

                            <i
                              className="las la-map-marker-alt"
                              onClick={() =>
                                handleMapIconClick(position.LAT, position.LON)
                              }
                              style={{
                                cursor: "pointer",
                                marginLeft: "5px",
                                fontSize: "20px",
                                color: "red",
                              }}
                            ></i>
                          </div>
                        </td>
                      </tr>

                    ))
                  ) : (

                    <tr>
                      <td colSpan={9}>No positions available</td>
                    </tr>

                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <span>
              {translate("Displaying")} {positions.length} {translate("out of")}{" "}
              {total}
            </span>
          </div>
          <div className="col-md-6">
            <ReactPaginate
              previousLabel={translate("previous")}
              nextLabel={translate("next")}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-end"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
              forcePage={currentPage - 1}
            />
          </div>


        </div>
        <MapModal
          show={showMapModal}
          onClose={() => setShowMapModal(false)}
          lat={markerCoordinates.LAT}
          lng={markerCoordinates.LON}
        />
      </>
      {/* Ajoutez le reste de votre code, comme le graphique */}
      <div style={{ minHeight: "400px" }}>
        <Linecharts {...sampleData} />
      </div>
      <MapModal
        show={modalInfo.show}
        onClose={() => setModalInfo({ show: false, lat: 0, lng: 0 })}
        lat={modalInfo.lat}
        lng={modalInfo.lng}
      />
    </>
  );
}
